import { render, staticRenderFns } from "./TwoSon.vue?vue&type=template&id=7da30810&scoped=true"
import script from "./TwoSon.vue?vue&type=script&lang=js"
export * from "./TwoSon.vue?vue&type=script&lang=js"
import style0 from "./TwoSon.vue?vue&type=style&index=0&id=7da30810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da30810",
  null
  
)

export default component.exports